import { render, staticRenderFns } from "./GiftTable.vue?vue&type=template&id=37167750&scoped=true"
import script from "./GiftTable.vue?vue&type=script&lang=js"
export * from "./GiftTable.vue?vue&type=script&lang=js"
import style0 from "./GiftTable.vue?vue&type=style&index=0&id=37167750&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37167750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37167750')) {
      api.createRecord('37167750', component.options)
    } else {
      api.reload('37167750', component.options)
    }
    module.hot.accept("./GiftTable.vue?vue&type=template&id=37167750&scoped=true", function () {
      api.rerender('37167750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/GiftTable.vue"
export default component.exports